export const Price = ({ amount, prefix = "", suffix = "" }) => {
  return (
    <span className="inline-flex items-baseline gap-1 font-inter tabular-nums text-[#c9a961]">
      {prefix && <span className="text-sm">{prefix}</span>}
      <span className="text-[10px] leading-none text-[#c9a961]/70">$</span>
      <span className="text-base font-semibold tracking-tight sm:text-lg">
        {amount}
      </span>
      {suffix && (
        <span className="ml-1 text-[10px] uppercase tracking-widest text-[#c9a961]/70">
          {suffix}
        </span>
      )}
    </span>
  );
};
